import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { logger } from 'app/core/util/logger';
import { Observable, of } from 'rxjs';
import { appSettings } from 'app/appSettings';
import { AdminDefinitionsTO } from '../../../store/admin/admin-definitions/admin-definitions.model';
import { RestService } from '../rest.service';
import { default as cachedResponse } from './responses/getAdminDefinitions';

@Injectable({ providedIn: 'root' })
export class AdminDefinitionRestService {
  constructor(private restService: RestService, private translate: TranslateService) {}

  getAdminDefinitions(language: string): Observable<AdminDefinitionsTO> {
    if (appSettings.USE_MOCK_REST_DATA) {
      logger.log('MOCK REST getAdminDefinitions');
      return of(cachedResponse as AdminDefinitionsTO);
    } else {
      return this.restService.get<AdminDefinitionsTO>(`/Definition/getAdmin?language=${(language || 'en').toUpperCase()}`);
    }
  }
}
